import App from './App'
import enhance from './App.enhancer'

export default enhance(App)



// WEBPACK FOOTER //
// ./src/containers/core/App/index.js